module.exports = __webpack_public_path__ + "static/media/chronicprog.c5d4756f.png";